import * as Sentry from '@sentry/nextjs'
import { removeSkuPrefix } from 'src/util/Linx'
import {
  renderSnippet as renderSnippetGtm,
  renderSnippetNoScript as renderSnippetNoScriptGtm,
} from './snippet-gtm'

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID
const CURRENCY_CODE = 'BRL'

if (typeof window !== 'undefined') window.dataLayer = window.dataLayer || []

export const gtmProduto = (
  conteudoProduto: any,
  variacaoAtiva: any,
  gtmProdProps?: any
) => {
  if (!conteudoProduto || !variacaoAtiva) return null
  const anuncioProduto = variacaoAtiva.anuncios[0]
  const variacao = variacaoAtiva?.combinacoes.reduce(
    (result: any, item: any) => {
      if (
        (item.atributo_slug === 'voltagem' &&
          item.valor_slug != 'sem-voltagem') ||
        (item.atributo_slug === 'cor' && item.valor_slug != 'sem-cor')
      ) {
        result.push(item.valor)
      }
      return result
    },
    []
  )

  return {
    name: conteudoProduto.titulo,
    id: variacaoAtiva.id,
    price:
      anuncioProduto.formas_pagamento?.boleto?.por ?? anuncioProduto.preco.por,
    brand: conteudoProduto.marca_slug,
    category: conteudoProduto.categoria.nome,
    variant: variacao.join(','),
    ...gtmProdProps,
  }
}

const gtmProdutoFromLinx = (product: any, gtmProdProps?: any) => {
  if (!product || !gtmProdProps) return

  return {
    ...gtmProdProps,
    name: product.name,
    id: product.selectedSku,
    price: product.price,
    /*brand: product.brand,*/
    category: product.cId,
    variant: product?.specs?.cor?.[0]?.label ?? '',
    /*list: 'Search Results',*/
  }
}

export const renderSnippet = (nonce: string) => renderSnippetGtm(nonce, GTM_ID)

export const renderSnippetNoScript = () => renderSnippetNoScriptGtm(GTM_ID)

export const pageView = () => {
  try {
    window.dataLayer.push({ event: 'pageview' })
  } catch (err) {
    Sentry.captureException(err)
  }
}

export const impressions = (productList: any) => {
  if (!productList?.length) return

  let index = 0
  const gtmProductList = productList.reduce(
    (accumulated: any, product: any) => {
      return [
        ...accumulated,
        ...(product.skus?.map((productVariation: any) => {
          const gtmProduct = gtmProdutoFromLinx(product, { position: index })

          ++index

          return {
            ...gtmProduct,
            id: removeSkuPrefix(productVariation?.sku),
            variant: productVariation.specs?.cor?.[0],
            price: productVariation.properties.price,
          }
        }) || []),
      ]
    },
    []
  )

  try {
    window.dataLayer.push({
      ecommerce: {
        currencyCode: CURRENCY_CODE,
        impressions: gtmProductList,
      },
    })
  } catch (err) {
    Sentry.captureException(err)
  }
}

export const productClick = (product: any, callback?: () => void) => {
  const gtmProduct = gtmProdutoFromLinx(product)

  try {
    window.dataLayer.push({
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: { list: '' },
          products: [gtmProduct],
        },
      },
      eventCallback: callback,
    })
  } catch (err) {
    Sentry.captureException(err)
  }
}

export const productDetails = (conteudoProduto: any, variacaoAtiva: any) => {
  const gtmProd = gtmProduto(conteudoProduto, variacaoAtiva)
  if (!gtmProd) return

  try {
    window.dataLayer.push({
      ecommerce: {
        detail: {
          actionField: { list: '' }, // 'detail' actions have an optional list property.
          products: [gtmProd],
        },
      },
    })
  } catch (err) {
    Sentry.captureException(err)
  }
}

export const addToCart = (produto: any) => {
  try {
    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: CURRENCY_CODE,
        add: {
          products: [produto],
        },
      },
    })
  } catch (err) {
    Sentry.captureException(err)
  }
}

export const removeFromCart = (produto: any) => {
  try {
    window.dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: [produto],
        },
      },
    })
  } catch (err) {
    Sentry.captureException(err)
  }
}
